import * as React from 'react';

export function Tabs({
  value,
  defaultValue,
  onValueChange,
  children,
  className
}) {
  const isControlled = value !== undefined;
  const [current, setCurrent] = React.useState(value ?? defaultValue ?? '');

  React.useEffect(() => {
    if (isControlled) setCurrent(value);
  }, [value]);

  const handleChange = (val) => {
    if (!isControlled) {
      setCurrent(val);
    }
    if (onValueChange) onValueChange(val);
  };

  // Children will be TabsList and TabsContent
  return (
    <div className={className}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, {
          value: current,
          onValueChange: handleChange
        });
      })}
    </div>
  );
}

export function TabsList({ children, value, onValueChange, className }) {
  return (
    <div
      className={
        'inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground ' +
        (className || '')
      }>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, {
          selected: child.props.value === value,
          onClick: () => onValueChange(child.props.value)
        });
      })}
    </div>
  );
}

export function TabsTrigger({ value, selected, onClick, children, className }) {
  return (
    <button
      type="button"
      className={
        `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ` +
        (selected
          ? 'bg-background text-foreground shadow-sm'
          : 'text-muted-foreground hover:bg-background/60 hover:text-foreground') +
        (className ? ' ' + className : '')
      }
      onClick={onClick}
      data-state={selected ? 'active' : 'inactive'}
      aria-selected={selected}
      tabIndex={selected ? 0 : -1}>
      {children}
    </button>
  );
}

export function TabsContent({ value, tabValue, children, className }) {
  if (value !== tabValue) return null;
  return <div className={className}>{children}</div>;
}
